import { render, staticRenderFns } from "./ProductCategoryRow.vue?vue&type=template&id=38e486e4&scoped=true"
import script from "./ProductCategoryRow.vue?vue&type=script&lang=js"
export * from "./ProductCategoryRow.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryRow.vue?vue&type=style&index=0&id=38e486e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e486e4",
  null
  
)

export default component.exports